import mapValues from 'lodash/mapValues'

const trimFields = (fields) =>
  mapValues(fields, (value) => typeof value === 'string' ? value.trim() : value)

export default trimFields
